document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains("animation-active")) {
        entry.target.classList.add("animation-active");
      }
    });
  }, { threshold: 0.3 }); // 元素有 30% 出现在视口时触发

  $('.bg-animation').each(function() {
    observer.observe(this);
  });
})